export { default } from './FooterCopyright';
